<template>
  <svg viewBox="0 0 18 18"><path fill-rule="nonzero" d="M8.75 0a.75.75 0 01.743.648L9.5.75V8h7.25l.12.008c.84.11.84 1.375 0 1.484l-.12.008H9.5v7.25a.75.75 0 01-1.493.102L8 16.75V9.5H.75a.75.75 0 01-.102-1.493L.75 8H8V.75A.75.75 0 018.75 0z" /></svg>
</template>

<script>
export default {
  name: 'Add'
}
</script>
